import React from 'react';
import { Button, Tag } from 'antd';
import classNames from 'classnames';
import { CheckCircleFilled, PlusOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { IAbandonedBusinessDish } from '../../interfaces/abandoned-business/IAbandonedBusinessDish';

import DishQuantityControl from './DishQuantityControl';
import { CATEGORY_COLORS } from './utils/categoryColors';
import { CHECK_ICON, IMG_WRAP, TAG_STYLE } from './utils/dishCardInlineStyles';

type ProductTypeData = { value: string; color: string; textKey: string };
export enum ProductType {
  DRINKS = 'Drinks',
  DESERTS = 'Deserts',
  MAIN = 'Main',
  OTHERS = 'Others',
}

const PRODUCT_TYPE_DATA: ProductTypeData[] = [
  { value: ProductType.MAIN, color: 'green', textKey: 'main' },
  { value: ProductType.DESERTS, color: 'blue', textKey: 'deserts' },
  { value: ProductType.DRINKS, color: 'orange', textKey: 'drinks' },
  { value: ProductType.OTHERS, color: 'purple', textKey: 'fruits' },
];

type Props = {
  dish: IAbandonedBusinessDish;
  isSelected: boolean;
  quantity: number;
  onToggle: () => void;
  onQuantityChange: (qty: number) => void;
};

const DishSelectionCard: React.FC<Props> = ({
  dish,
  isSelected,
  quantity,
  onToggle,
  onQuantityChange,
}) => {
  const { t } = useTranslate();

  const categoryMeta = PRODUCT_TYPE_DATA.find(
    tpe => tpe.value === dish.category,
  );

  const baseUrl = process.env.REACT_APP_BASE_URL_IMAGE;

  const handleClick = isSelected ? undefined : onToggle;
  const handleKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !isSelected) onToggle();
  };

  return (
    <div className={classNames('ab-dish-item', { 'is-selected': isSelected })}>
      <div className='dish-item'>
        <div
          style={IMG_WRAP}
          onClick={handleClick}
          role='button'
          tabIndex={0}
          onKeyDown={handleKey}
        >
          <img
            className='dish-item-image'
            src={`${baseUrl}/${dish.image}`}
            alt={dish.name}
          />
          {isSelected && <CheckCircleFilled style={CHECK_ICON} />}
        </div>
        <div
          style={{
            flex: 1,
            minWidth: 0,
            cursor: isSelected ? 'default' : 'pointer',
          }}
          onClick={handleClick}
          role='button'
          tabIndex={0}
          onKeyDown={handleKey}
        >
          <div className='dish-item-name'>{dish.name}</div>
          <div className='dish-item-meta'>
            <Tag color={categoryMeta?.color} style={TAG_STYLE}>
              {t(categoryMeta ? categoryMeta.textKey : dish.category)}
            </Tag>
          </div>
        </div>
        <div style={{ flexShrink: 0 }}>
          {isSelected ? (
            <DishQuantityControl
              quantity={quantity}
              onChange={onQuantityChange}
            />
          ) : (
            <Button
              size='small'
              icon={<PlusOutlined />}
              onClick={onToggle}
              className='dish-add-btn'
              type='link'
              variant='solid'
            >
              {t('Add')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DishSelectionCard;
